module.exports = __webpack_public_path__ + "img/expand-all.75b9c088.svg";